import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BrandingService } from '@feature/branding';
import { NavController } from '@ionic/angular';
import { Environment, EnvironmentService } from '@util/environment';

@Component({
  selector: 'ui-app-bar',
  templateUrl: './app-bar.component.html',
  styleUrls: ['./app-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UIAppBarComponent {
  private readonly env = inject(EnvironmentService);
  private readonly navCtrl = inject(NavController);
  private readonly brandingService = inject(BrandingService);

  private trigger = 0;

  alertEnv(): void {
    this.trigger++;
    if (this.trigger % 3 == 0) {
      const version: string = this.env.info.version;
      const { country, stage }: Environment = this.env.environment;
      const branding: Environment['branding'] = this.brandingService.brand();
      alert(`Environment: ${country}-${stage}\nVersion: ${version}\nBranding: ${branding}\nOrigin: ${window.origin}`);
    }
  }
}
